import { Outlet } from 'react-router-dom';

export function Layout() {
  return (
    <div className="px-4 py-2 md:px-6 lg:px-8">
      <Outlet />
    </div>
  );
}
